var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.5C28.6739 42.5 27.4021 41.9732 26.4645 41.0355C25.5268 40.0979 25 38.8261 25 37.5C25 34.725 27.225 32.5 30 32.5C31.3261 32.5 32.5979 33.0268 33.5355 33.9645C34.4732 34.9021 35 36.1739 35 37.5C35 38.8261 34.4732 40.0979 33.5355 41.0355C32.5979 41.9732 31.3261 42.5 30 42.5ZM45 50V25H15V50H45ZM45 20C46.3261 20 47.5979 20.5268 48.5355 21.4645C49.4732 22.4021 50 23.6739 50 25V50C50 51.3261 49.4732 52.5979 48.5355 53.5355C47.5979 54.4732 46.3261 55 45 55H15C13.6739 55 12.4021 54.4732 11.4645 53.5355C10.5268 52.5979 10 51.3261 10 50V25C10 22.225 12.225 20 15 20H17.5V15C17.5 11.6848 18.817 8.50537 21.1612 6.16117C23.5054 3.81696 26.6848 2.5 30 2.5C31.6415 2.5 33.267 2.82332 34.7835 3.45151C36.3001 4.07969 37.6781 5.00043 38.8388 6.16117C39.9996 7.3219 40.9203 8.69989 41.5485 10.2165C42.1767 11.733 42.5 13.3585 42.5 15V20H45ZM30 7.5C28.0109 7.5 26.1032 8.29018 24.6967 9.6967C23.2902 11.1032 22.5 13.0109 22.5 15V20H37.5V15C37.5 13.0109 36.7098 11.1032 35.3033 9.6967C33.8968 8.29018 31.9891 7.5 30 7.5Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.3173b84e9283a94d85101e4115a59635.svg";
export { ForwardRef as ReactComponent };